module.exports = __webpack_public_path__ + "img/logo-icon.af0d1c08.png";